<template>
  <div class="distribution-introduce">
    <div class="distribution-top">
      <div class="img-explain">
        <p class="img">
          <img src="../../../../assets/apply/selection.png" alt />
        </p>
        <div class="explain">
          <p class="title">分销模块</p>
          <p class="price">免费</p>
          <p class="text">裂变传播拉新客，躺着提升销售额</p>
          <div class="switch">
            <el-switch
              @change="changeStatus"
              v-model="switchValue"
              active-color="#3D74F2"
              inactive-color="#EBEDF1"
            ></el-switch>
          </div>
        </div>
      </div>
      <div class="relevant">
        <div class="title">相关信息</div>
        <p class="number">暂无详情</p>
      </div>
    </div>
    <div class="distribution-bottom">
      <div class="title">应用介绍</div>
      <div class="text">
        <img src="../../../../assets/apply/nothing.png" alt />
        <p>暂无介绍记录</p>
      </div>
    </div>
  </div>
</template>

<script>
import Apply from "models/db/apply";
const apply = new Apply();
export default {
  data() {
    return {
      switchValue: false,
    };
  },
  created() {
    this.$emit("childMueu", "分销模块");
    this.getDetailData();
  },
  methods: {
    // 获取当前页数据
    getDetailData() {
      apply.getSupplierInviteDetail().then((res) => {
        console.log(res);
        if (res.success) {
          this.switchValue = res.result.status === 1 ? true : false;
        }
      });
    },
    changeStatus() {
      let status = this.switchValue ? 1 : 0;
      let data = {
        status,
      };
      apply.postSupplierInviteUpdate(data).then((res) => {
        if (res.success) {
          if (status === 1) {
            this.$message.success("已开启");
          } else {
            this.$message.success("已关闭");
          }
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.distribution-introduce {
  padding: 32px;
  min-height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .distribution-top {
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    margin-bottom: 16px;
    box-sizing: border-box;
    padding: 16px;
    .img-explain {
      display: flex;
      margin-bottom: 20px;
      .img {
        width: 140px;
        height: 140px;
        box-shadow: 0px 0px 12px rgba($color: #233446, $alpha: 0.1);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-right: 30px;
        img {
          width: 60px;
        }
      }
      .explain {
        margin-top: 10px;
        .title {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 16px;
        }
        .price {
          color: #df3445;
          font-size: 16px;
          margin-bottom: 16px;
        }
        .text {
          color: #666666;
          font-size: 14px;
          margin-bottom: 16px;
        }
      }
    }
    .relevant {
      .title {
        padding-left: 16px;
        font-size: 16px;
        border-left: 4px solid #3d74f2;
        margin-bottom: 16px;
      }
      .number {
        padding-left: 20px;
        font-size: 14px;
      }
    }
  }
  .distribution-bottom {
    flex: 1;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    box-sizing: border-box;
    padding: 16px;
    .title {
      padding-left: 16px;
      font-size: 16px;
      border-left: 4px solid #3d74f2;
    }
    .text {
      display: flex;
      flex-direction: column;
      padding-top: 10px;
      align-items: center;
      p {
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
</style>